import React from "react";
import "./ContactForm.css";
import Dots from "../../../../assets/images/about-shape3.png";
import Triangle1 from "../../../../assets/images/contactformtri1.png";
const ContactForm = () => {
  return (
    <div className="contact__form_section">
      <img src={Dots} alt="" className="contact__form_dots" />
      <div className="contact__formwrap">
        <img src={Triangle1} alt="" className="contact__formtriangle1" />
        <div className="contact__form">
          <div className="contact__form_heading">Get In Touch</div>
          <form className="contact__formcontent">
            <div className="contact__formrow">
              <div className="contact__formcolleft">
                <label className="contact__formlabel">Name</label>
                <input
                  className="contact__formfield"
                  type="text"
                  placeholder="Your Full Name"
                />
              </div>
              <div className="contact__formcol">
                <label className="contact__formlabel">Email</label>
                <input
                  className="contact__formfield"
                  type="Email"
                  placeholder="Enter Your Email"
                />
              </div>
            </div>
            <div className="contact__formrow">
              <div className="contact__formcolleft">
                <label className="contact__formlabel">Phone Number</label>
                <input
                  className="contact__formfield"
                  type="text"
                  placeholder="Enter Your Number"
                />
              </div>
              <div className="contact__formcol">
                <label className="contact__formlabel">Your Website</label>
                <input
                  className="contact__formfield"
                  type="text"
                  placeholder="Enter Your Webite"
                />
              </div>
            </div>
            <div className="contact__formrow">
              <div className="contact__formcol">
                <label className="contact__formlabel">Your Message</label>
                <textarea
                  className="contact__formtextarea"
                  placeholder="Write your message here..."
                ></textarea>
              </div>
            </div>
            <div className="contact__formrow">
              <div className="contact__formcol">
                <button className="contact__formsubmit_btn">Submit Now</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
